import React from 'react'
import {Icon, Modal, Header, Button} from 'semantic-ui-react';
import {useSelector, useDispatch} from 'react-redux';
import * as moment from 'moment'
import { useFirestore } from 'react-redux-firebase';
import * as EventtickerActions from '../../actions/EventtickerActions';

export const NoResults = (props) => {
    const searchresult = useSelector((state) => state.eventticker.get('search').toJS());
    const dispatch = useDispatch();
    const firestore = useFirestore();

    return (
        <Modal closeOnDocumentClick={true} closeOnDimmerClick={true} open={true}  basic size='small' onClose={(e) => {
            dispatch(EventtickerActions.close_search());
        }}>
            <Modal.Content>
                <p>
                    Es wurden keine Events zu dieser Plus-Nummer gefunden.
                </p>
            </Modal.Content>
            <Modal.Actions>
                <Button basic color='red' inverted onClick={(e) => {
                    dispatch(EventtickerActions.close_search());
                }}>
                    <Icon name='remove' /> Schließen
                </Button>
            </Modal.Actions>
        </Modal>
    )
}